import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      <div className="container-main py-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {/* Left Column - Brand */}
          <div className="md:col-span-5">
            <h2
              className="text-xl sm:text-2xl font-medium tracking-tight mb-4"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              Ready to get
              <br />
              better results?
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-3 bg-white text-slate-900 px-8 py-4 font-medium text-sm tracking-wide transition-all duration-300 hover:bg-gray-100"
            >
              Start a Conversation
              <ArrowRight size={18} />
            </Link>
          </div>

          {/* Right Column - Links */}
          <div className="md:col-span-7 md:flex md:justify-end">
            <div className="grid grid-cols-2 gap-6 sm:gap-12">
              {/* Navigation */}
              <div>
                <h3 className="label-text text-gray-400 mb-3">Navigation</h3>
                <nav className="flex flex-col space-y-2">
                  <Link to="/" data-testid="footer-home" className="footer-link">
                    Home
                  </Link>
                  <Link to="/about" data-testid="footer-about" className="footer-link">
                    About
                  </Link>
                  <Link to="/services" data-testid="footer-services" className="footer-link">
                    Services
                  </Link>
                  <Link to="/contact" data-testid="footer-contact" className="footer-link">
                    Contact
                  </Link>
                </nav>
              </div>

              {/* Contact */}
              <div>
                <h3 className="label-text text-gray-400 mb-3">Contact</h3>
                <div className="flex flex-col space-y-2">
                  <a
                    href="mailto:pdorsey@dorseyandassociates.com"
                    data-testid="footer-email"
                    className="footer-link break-all"
                  >
                    pdorsey@dorseyandassociates.com
                  </a>
                  <a
                    href="https://www.linkedin.com/in/patdorsey/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-linkedin"
                    className="footer-link flex items-center gap-2"
                  >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-6 pt-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="flex items-center justify-center w-10 h-10 border-2 border-white">
                <div className="text-white text-sm font-bold leading-none">
                  <div>D</div>
                  <div className="border-t border-white">A</div>
                </div>
              </div>
              <span className="text-white text-sm font-medium">Dorsey and Associates, LLC</span>
            </Link>
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Dorsey and Associates. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
